function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Header Section
 *    Provides scripts for elements within the header section.
 *
 *  Version:
 *    1.0.0 - 2020/02/09
 */

import { register, ShopifySection } from './../ShopifySection';
import { DesktopMenu, DESKTOP_MENU_SELECTOR } from './../../components/menu/DesktopMenu';
import { MobileMenu, MOBILE_MENU_SELECTOR } from './../../components/menu/MobileMenu';
import { ON_CART_FINISHED, getCurrentCart } from '@process-creative/slate-theme-tools';
import { TreeCount } from './../../objects/tree/TreeCount';
import { SearchBar, SEARCH_BAR_CONTAINER } from './../../components/search/SearchBar';
import { medium } from '../../settings/Responsive';

//Elements
export var CONTAINER_SELECTOR = '[data-header-container]';
export var HEADER_INNER = '[data-header-inner]';
export var TOP_BAR_SELECTOR = '[data-topbar]';
export var SEARCH_BAR_TOGGLE = '[data-search-toggle]';
var SEARCH_CLEAR = '[data-search-clear]';
export var GAUGE_PATH = '.gauge-path';
export var SEARCH_BAR = '[data-search-bar]';
export var SEARCH_INPUT = '[data-search-input-desktop]';
export var HELP_MODAL = '[data-help-modal]';
export var HELP_MODAL_TOGGLE = '[data-help-modal-trigger]';
export var CART_COUNTER = '[data-cart-counter]';
export var PRODUCT_TEMPLATE_SELECTOR = '[data-product-template]';
export var PRODUCT_STICKY_SELECTOR = '[data-product-sticky]';

//Classes
export var CLASS_FIXED = 'is-fixed';
export var CLASS_DOWN = 'is-scroll-down';
export var CLASS_OPEN = 'is-open';
export var CLASS_STICKY = 'is-product-sticky';
export var CLASS_FAUX = 'faux';
var CLASS_TRANSPARENT = 'is-transparent';

//Trigger Variables
export var HEADER_SWAP_TRIGGER = 400;
export var HEADER_SCROLL_UP_TRIGGER = 200;
export var HeaderSection = /*#__PURE__*/function (_ShopifySection) {
  _inherits(HeaderSection, _ShopifySection);
  var _super = _createSuper(HeaderSection);
  function HeaderSection(container) {
    var _this;
    _classCallCheck(this, HeaderSection);
    _this = _super.call(this, container);
    _this.desktopMenu = new DesktopMenu(_assertThisInitialized(_this), container.find(DESKTOP_MENU_SELECTOR));
    _this.mobileMenu = new MobileMenu(container, container.find(MOBILE_MENU_SELECTOR));
    _this.treeCounter = new TreeCount();
    _this.inner = container.find(HEADER_INNER);
    _this.topBar = container.find(TOP_BAR_SELECTOR);
    _this.searchInput = container.find(SEARCH_INPUT);
    _this.searchBar = container.find(SEARCH_BAR_CONTAINER);
    _this.searchBarShow = container.find(SEARCH_BAR_TOGGLE);
    _this.search = new SearchBar(_this.searchBar);
    _this.helpModal = container.find(HELP_MODAL);
    _this.helpToggle = container.find(HELP_MODAL_TOGGLE);
    _this.cartCount = container.find(CART_COUNTER);
    _this.mobileMenuElement = container.find(MOBILE_MENU_SELECTOR);
    _this.productTemplate = $(PRODUCT_TEMPLATE_SELECTOR);
    _this.productSticky = $(PRODUCT_STICKY_SELECTOR);
    _this.gaugePath = _this.container.find(GAUGE_PATH);
    _this.dashOffset = _this.gaugePath.css('stroke-dashoffset');
    _this.searchElements = [_this.searchBar, _this.searchBarShow];
    _this.helpElements = [_this.helpModal, _this.helpToggle];
    container.on('click touchend', SEARCH_BAR_TOGGLE, function (e) {
      return _this.onSearchToggle(e);
    });
    container.on('click touchend', SEARCH_CLEAR, function (e) {
      return _this.search.clearSearch();
    });
    _this.checkPosition();
    _this.calculateHeaderHeight();
    _this.checkLogoInterval = setInterval(function () {
      return _this.checkLogo();
    }, 100);
    $(window).on('resize orientationchange', function () {
      return _this.calculateHeaderHeight();
    });
    container.on('click touch', HELP_MODAL_TOGGLE, function (e) {
      return _this.onHelpToggle(e);
    });
    $(document).on(ON_CART_FINISHED, function () {
      return _this.onCartFinished();
    });
    return _this;
  }
  _createClass(HeaderSection, [{
    key: "calculateHeaderHeight",
    value: function calculateHeaderHeight() {
      this.topbarHeight = this.topBar.outerHeight() || -1;
    }
  }, {
    key: "checkLogo",
    value: function checkLogo() {
      this.gaugePath = this.container.find(GAUGE_PATH);
      if (!this.gaugePath.length) return;
      this.dashOffset = this.gaugePath.css('stroke-dashoffset');
      clearInterval(this.checkLogoInterval);
    }
  }, {
    key: "checkPosition",
    value: function checkPosition() {
      var _this2 = this;
      var top = $(window).scrollTop();

      //Fix our topbar element
      if (top > this.topbarHeight) {
        this.inner.addClass(CLASS_FIXED);
        this.mobileMenuElement.addClass(CLASS_FIXED);
      } else {
        this.inner.removeClass(CLASS_FIXED);
        this.mobileMenuElement.removeClass(CLASS_FIXED);
        var offset = this.topbarHeight - top + this.inner.outerHeight();
        if (offset != this.offset) {
          this.mobileMenuElement.css('top', "".concat(offset, "px"));
          this.offset = offset;
        }
      }

      //Are we scrolling down or up?
      if (this.top < top && top > HEADER_SWAP_TRIGGER) {
        this.inner.addClass(CLASS_DOWN);
        this.scrollDown = true;
      } else if (top < this.top) {
        this.inner.removeClass(CLASS_DOWN);
        this.scrollDown = false;
      }

      //Are we on a product page and does the sticky bar exist?
      if (this.productTemplate.length && this.productSticky.length) {
        var productTop = this.productTemplate.offset().top;
        var productHeight = this.productTemplate.height();
        if (top > productTop + productHeight && this.scrollDown) {
          this.productSticky.addClass(CLASS_STICKY);
          this.inner.addClass(CLASS_STICKY);
        } else {
          this.productSticky.removeClass(CLASS_STICKY);
          this.inner.removeClass(CLASS_STICKY);
        }
      }

      //Circle animation, targets gaugepath value of the path
      if (this.gaugePath && top != this.top) {
        //Calculate our percentage based on the page size & convert to 
        var percent = top / ($("html").height() - $(window).height());
        //Subtraction and dashoffset amount may need updating if the SVG changes.
        var subtraction = 110 * percent;
        this.gaugePath.css('stroke-dashoffset', parseInt(1000 - subtraction));
        this.gaugePath.addClass(CLASS_FAUX).removeClass(CLASS_FAUX);
      }

      //Reset the variable
      this.top = top;
      requestAnimationFrame(function () {
        return _this2.checkPosition();
      });
    }
  }, {
    key: "onCartFinished",
    value: function onCartFinished() {
      var _getCurrentCart = getCurrentCart(),
        item_count = _getCurrentCart.item_count;
      if (item_count > 0) {
        this.cartCount.html(item_count);
      } else {
        this.cartCount.html('');
      }
    }
  }, {
    key: "onHelpToggle",
    value: function onHelpToggle(e) {
      var _this3 = this;
      e.preventDefault();
      e.stopPropagation();

      //Hide Search Bar, if visible
      if (this.searchBar.hasClass(CLASS_OPEN)) {
        this.searchElements.forEach(function (e) {
          return $(e).removeClass(CLASS_OPEN);
        });
      }
      this.helpElements.forEach(function (e) {
        return $(e).toggleClass(CLASS_OPEN);
      });
      if (this.helpModal.hasClass(CLASS_OPEN)) {
        $(document).on('click', function (e) {
          return _this3.onClickOutsideHelp(e);
        });
      } else {
        $(document).off('click', function (e) {
          return _this3.onClickOutsideHelp(e);
        });
      }
    }
  }, {
    key: "onClickOutsideHelp",
    value: function onClickOutsideHelp(e) {
      var _this4 = this;
      var check = $(HELP_MODAL).find(e.target);
      if (check.length) return;
      this.helpElements.forEach(function (e) {
        return $(e).removeClass(CLASS_OPEN);
      });
      $(document).off('click', function (e) {
        return _this4.onClickOutsideHelp(e);
      });
    }
  }, {
    key: "onClickOutsideSearch",
    value: function onClickOutsideSearch(e) {
      var _this5 = this;
      var check = $(SEARCH_BAR).find(e.target);
      if (check.length) return;
      this.searchElements.forEach(function (e) {
        return $(e).removeClass(CLASS_OPEN);
      });
      if (this.hadTransparent) {
        this.container.addClass(CLASS_TRANSPARENT);
      }
      $(document).off('click', function (e) {
        return _this5.onClickOutsideSearch(e);
      });
    }
  }, {
    key: "onSearchToggle",
    value: function onSearchToggle(e) {
      var _this6 = this;
      e.preventDefault();
      e.stopPropagation();

      //Hide Help Modal, if visible
      if (this.helpModal.hasClass(CLASS_OPEN)) {
        this.helpElements.forEach(function (e) {
          return $(e).removeClass(CLASS_OPEN);
        });
      }
      var desktopSearch = this.inner.find(SEARCH_BAR_CONTAINER);
      var desktopSearchInput = this.inner.find('[data-search-input]');
      this.searchElements.forEach(function (e) {
        return $(e).toggleClass(CLASS_OPEN);
      });
      if (desktopSearch.hasClass(CLASS_OPEN)) {
        setTimeout(function () {
          return desktopSearchInput.focus();
        }, 250);
        $(document).on('click.outsideSearch', function (e) {
          return _this6.onClickOutsideSearch(e);
        });
        if (this.container.hasClass(CLASS_TRANSPARENT)) {
          this.container.removeClass(CLASS_TRANSPARENT);
          this.hadTransparent = true;
        }
      } else {
        this.mobileMenu.close();
        $(document).off('click.outsideSearch', function (e) {
          return _this6.onClickOutsideSearch(e);
        });
        if (this.hadTransparent) {
          this.container.addClass(CLASS_TRANSPARENT);
        }
      }
    }
  }]);
  return HeaderSection;
}(ShopifySection);
register(CONTAINER_SELECTOR, HeaderSection);